import { WalletPass } from '../interfaces/interface.wallet-pass';
import { fetchWalletPass } from '../services/service.wallet-pass';
import { state as offerState } from '../store/store.offer';
import { trackAppleWalletBadgeClick } from '../tracking/tracking.wallet-pass';
import { APPLE_PLATFORM, extractFileName } from '../utils/util.wallet-pass';
import { UserAgent, getUserAgent } from '../utils/utils.browser';

export const onAppleWalletBadgeClick = async (modalRef?: HTMLIcoModalElement): Promise<void> => {
  handleWalletBadgeClick(APPLE_PLATFORM, modalRef);
  trackAppleWalletBadgeClick();
};

const handleWalletBadgeClick = async (platform: string, modalRef?: HTMLIcoModalElement): Promise<void> => {
  const validUserAgent = platform === APPLE_PLATFORM ? [UserAgent.IOS, UserAgent.MACOS] : [UserAgent.ANDROID];
  if (validUserAgent.includes(getUserAgent())) {
    await downloadWalletPass(platform);
  } else {
    modalRef && modalRef.open();
  }
};

const downloadWalletPass = async (platform: string): Promise<void> => {
  try {
    const response = await fetchWalletPass(offerState.offerId, platform);
    const walletPass = await processResponse(response);
    await download(walletPass);
  } catch (error) {
    console.error('Error fetching wallet pass:', error);
  }
};

const processResponse = async (response: Response): Promise<WalletPass> => {
  const contentDisposition = response.headers.get('content-disposition');
  return {
    blob: await response.blob(),
    fileName: extractFileName(contentDisposition) || offerState.offerId,
  };
};

const download = async (walletPass: WalletPass): Promise<void> => {
  try {
    // Create a link element to download the blob
    const url = window.URL.createObjectURL(walletPass.blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = walletPass.fileName;

    // Trigger the download
    document.body.appendChild(link);
    link.click();

    // Clean up
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading wallet pass:', error);
  }
};
